import DetailsReviewContainer from "./DetailsReviewContainer";

export default DetailsReviewContainer;
